import { ComponentIds } from '@inter-ikea-core/core';
import FrameTopComponent, { FrameTopComponentSerializer } from '../components/FrameTopComponent';
import { PlannerEcsSystem } from './System';
import EventComponent from '../components/EventComponent';
/**
 * This system handles adding and removing top panels on frames
 */
export class TopPanelSystem extends PlannerEcsSystem {
    constructor(coreApi, topPanelProductType) {
        super(coreApi, 'TopPanelSystem', EventComponent.id);
        this.coreApi = coreApi;
        this.topPanelProductType = topPanelProductType;
        this.topPanelProducts = [];
        const componentDeserializerRegistry = this.coreApi.getServices().componentDeserializerRegistry;
        componentDeserializerRegistry.register(new FrameTopComponentSerializer());
    }
    setMarketProducts(marketProducts) {
        this.topPanelProducts = marketProducts.filter(p => p.type === this.topPanelProductType);
    }
    onAdd() { }
    onUpdate(entity, oldComponent, newComponent) {
        if (newComponent.event === 'history') {
            if (this.topPanelProducts.length === 0) {
                return;
            }
            this.updateTops();
        }
    }
    onRemove() { }
    updateTops() {
        const frames = this.coreApi.entities.getByComponent(ComponentIds.FRAME_COMPONENT_ID);
        const framesAbove180 = [];
        const framesBelow180 = [];
        frames
            .filter(frame => !frame.hasComponent(FrameTopComponent.id))
            .forEach(frame => {
            const position = frame.getComponent(ComponentIds.WORLD_TRANSFORM_COMPONENT_ID)?.transform.position;
            const frameHeight = this.coreApi.entities.getEntityComSize(frame)?.height;
            if (position && frameHeight && position.Y + frameHeight / 2 < TOP_PANEL_HEIGHT_LIMIT) {
                framesBelow180.push(frame);
            }
            else {
                framesAbove180.push(frame);
            }
        });
        this.removeTops(framesAbove180);
        this.addTops(framesBelow180, false);
    }
    addTopstoExistingFramesAtRecommendedPosition(frames) {
        const framesBelow180 = [];
        frames.forEach(frame => {
            const position = frame.getComponent(ComponentIds.WORLD_TRANSFORM_COMPONENT_ID)?.transform.position;
            const frameHeight = this.coreApi.entities.getEntityComSize(frame)?.height;
            if (position && frameHeight && frameIsBelowTopLevelLimit(position, frameHeight)) {
                framesBelow180.push(frame);
            }
        });
        this.addTops(framesBelow180, true);
    }
    disposeTops(tops) {
        if (tops.length === 0)
            return;
        tops.forEach(top => {
            if (!top.isDisposed)
                this.coreApi.getServices().entityManager.disposeEntity(top);
        });
    }
    removeTops(frames) {
        frames.forEach(frame => {
            // If the frame is dragged, wait until it is placed before removing the tops
            // Earlier this caused an issue where the hierarchy was not updated correctly
            if (frame.hasComponent(ComponentIds.IS_DRAGGED_COMPONENT_ID)) {
                return;
            }
            const tops = this.coreApi.entities.getChildrenWithProductType(frame, this.topPanelProductType);
            this.disposeTops(tops);
        });
    }
    removeCurrentTops() {
        this.coreApi.history.historyAction(() => {
            const tops = this.coreApi.entities.getByProductType(this.topPanelProductType);
            this.disposeTops(tops);
        });
    }
    addTops(frames, withHistory) {
        frames.forEach(frame => {
            const topEntity = this.coreApi.entities.create(this.topPanelProducts[0].coreProductId);
            if (topEntity) {
                const result = withHistory
                    ? this.coreApi.placementService.snapToTarget(topEntity, frame)
                    : this.coreApi.placementService.snapToTarget(topEntity, frame);
                if (!result?.placedEntity) {
                    if (!topEntity.isDisposed)
                        this.coreApi.getServices().entityManager.disposeEntity(topEntity);
                }
            }
        });
    }
}
export const frameIsBelowTopLevelLimit = (position, frameHeight) => {
    return position.Y + frameHeight / 2 < TOP_PANEL_HEIGHT_LIMIT;
};
export const TOP_PANEL_HEIGHT_LIMIT = 1800;
//# sourceMappingURL=TopPanelSystem.js.map